import React, { useState } from 'react';

const FilterSidebar = ({ isOpen, onClose, onApplyFilter }) => {
  // State to manage filter inputs
  const [filters, setFilters] = useState({
    threadId: '',
    senderEmail: '',
    subject: '',
    emailAddress: '',
  });

  // Handle input changes
  const handleChange = (field, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [field]: value,
    }));
  };

  // Apply search filters
  const handleApply = () => {
    onApplyFilter(filters); // Pass filters to parent component
    onClose(); // Close the sidebar
  };

  // Clear all input fields
  const handleClear = () => {
    setFilters({
      threadId: '',
      senderEmail: '',
      subject: '',
      emailAddress: '',
    });
  };

  return (
    <>
      {/* Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-[#96A8AD73] bg-opacity-40 z-40"
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <div
        className={`fixed right-0 px-5 top-0 h-full w-1/4 bg-white shadow-lg z-50 transform ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        } transition-transform duration-300`}
      >
        <div className="flex flex-col h-full p-6">
          {/* Header */}
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-xl font-bold"> Advanced Search</h3>
            <button onClick={onClose} className="text-font-LIGHT px-2 py-1 hover:bg-bg-Gray hover:rounded-full">
              ✕
            </button>
          </div>
          <hr className="pb-4 w-full border-t border-gray-300" />
          {/* Form Fields */}
          <div className="flex flex-col py-4 gap-6 flex-grow">
            {/* Thread ID */}
            <div>
              <label className="block text-sm font-bold mb-2">Case Number</label>
              <input
                type="text"
                className="w-full px-3 border-black py-3 border rounded focus:outline-none focus:ring-1 focus:border-logo focus:ring-logo"
                placeholder="Enter Case Number"
                value={filters.threadId}
                onChange={(e) => handleChange('threadId', e.target.value)}
              />
            </div>

            {/* Sender Email */}
            <div>
              <label className="block text-sm font-bold mb-2">Sender Email</label>
              <input
                type="email"
                className="w-full px-3 border-black py-3 border rounded focus:outline-none focus:ring-1 focus:border-logo focus:ring-logo"
                placeholder="Enter Sender Email"
                value={filters.senderEmail}
                onChange={(e) => handleChange('senderEmail', e.target.value)}
              />
            </div>

            {/* Subject */}
            <div>
              <label className="block text-sm font-bold mb-2">Subject</label>
              <input
                type="text"
                className="w-full px-3 border-black py-3 border rounded focus:outline-none focus:ring-1 focus:border-logo focus:ring-logo"
                placeholder="Enter Subject"
                value={filters.subject}
                onChange={(e) => handleChange('subject', e.target.value)}
              />
            </div>

            {/* Email Address */}
            <div>
              <label className="block text-sm font-bold mb-2">Email Address</label>
              <input
                type="email"
                className="w-full px-3 py-3 border-black border rounded focus:outline-none focus:ring-1 focus:border-logo focus:ring-logo"
                placeholder="Enter Email Address"
                value={filters.emailAddress}
                onChange={(e) => handleChange('emailAddress', e.target.value)}
              />
            </div>
          </div>

          {/* Footer Actions */}
          <div className="flex justify-between items-center mt-4">
            {/* Clear All */}
            <button
              className="text-gray-700 text-sm px-6 py-3 rounded-full hover:bg-bg-Gray"
              onClick={handleClear}
            >
              Clear all
            </button>

            {/* Apply Search */}
            <button
              className="bg-logo text-white text-sm font-semibold px-6 py-3 rounded-full hover:bg-logo-darker hover:bg-logo-darker"
              onClick={handleApply}
            >
              Apply search
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterSidebar;